import {
  dateFormatter,
  DateTimeFormatter,
} from "components/displays/DisplayHelper";
import React from "react";
import { useTranslation } from "react-i18next";
import { Icon, Table } from "semantic-ui-react";
import moment from "moment-timezone";

const DocumentAuditTrailTable = ({
  data,
  state,
  events,
  tablesToShow,
  setTablesToShow,
}) => {
  const { t } = useTranslation("documentAuditTrails");

  const { t: tState } = useTranslation("enums", {
    keyPrefix: process.env.TRADE_AS_IPS
      ? "SheetStateIps"
      : "SheetStatePrincipal",
  });

  const { t: tPhysicalDocumentState } = useTranslation("enums", {
    keyPrefix: process.env.TRADE_AS_IPS
      ? "PhysicalDocumentSheetStateIps"
      : "PhysicalDocumentSheetStatePrincipal",
  });

  function toggleRow(id) {
    if (tablesToShow.indexOf(id) > -1) {
      let index = tablesToShow.indexOf(id);
      if (index !== -1) {
        const arrNew = [...tablesToShow];
        arrNew.splice(index, 1);
        setTablesToShow(arrNew);
      }
    } else {
      setTablesToShow(tablesToShow.concat(id));
    }
  }
  return (
    <Table className="document-audit-trail-table">
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell style={{ width: "2%" }}></Table.HeaderCell>
          <Table.HeaderCell>
            {t("AuditTrailTableHeaders.Supplier")}
          </Table.HeaderCell>
          <Table.HeaderCell>
            {t("AuditTrailTableHeaders.SupplierOffice")}
          </Table.HeaderCell>
          <Table.HeaderCell>
            {t("AuditTrailTableHeaders.DocumentNumber")}
          </Table.HeaderCell>
          <Table.HeaderCell>
            {t("AuditTrailTableHeaders.Customer")}
          </Table.HeaderCell>
          <Table.HeaderCell>
            {t("AuditTrailTableHeaders.DocusignEnvelopeId")}
          </Table.HeaderCell>
          <Table.HeaderCell>
            {t("AuditTrailTableHeaders.SentToDocusign")}
          </Table.HeaderCell>
          <Table.HeaderCell>
            {t("AuditTrailTableHeaders.SheetOwner")}
          </Table.HeaderCell>
          <Table.HeaderCell>
            {t("AuditTrailTableHeaders.LastUpdated")}
          </Table.HeaderCell>
          <Table.HeaderCell>
            {t("AuditTrailTableHeaders.Status")}
          </Table.HeaderCell>
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {data &&
          data.map((item, index) => (
            <React.Fragment key={item.id}>
              <Table.Row>
                <Table.Cell onClick={() => toggleRow(index)}>
                  <Icon
                    name="dropdown"
                    rotated={
                      !(tablesToShow.indexOf(index) > -1)
                        ? "counterclockwise"
                        : null
                    }
                  />
                </Table.Cell>
                <Table.Cell>{item.supplierName}</Table.Cell>
                <Table.Cell>{item.supplierOffice}</Table.Cell>
                <Table.Cell>{item.documentId}</Table.Cell>
                <Table.Cell>{item.customerName}</Table.Cell>
                <Table.Cell>{item.docuSignEnvelopeId}</Table.Cell>
                <Table.Cell>{item.sentToDocuSign}</Table.Cell>
                <Table.Cell>{item.sheetOwner}</Table.Cell>
                <Table.Cell>{item.lastUpdated}</Table.Cell>
                <Table.Cell>
                  {item.usePhysicalDocument
                    ? process.env.TRADE_AS_IPS
                      ? tPhysicalDocumentState(
                          item.physicalDocumentSheetStateIps,
                        )
                      : tPhysicalDocumentState(
                          item.physicalDocumentSheetStatePrincipal,
                        )
                    : process.env.TRADE_AS_IPS
                    ? tState(item.stateIps)
                    : tState(item.statePrincipal)}
                </Table.Cell>
              </Table.Row>
              <Table.Row hidden={!(tablesToShow.indexOf(index) > -1)}>
                <Table.Cell colSpan={11} className="sub-audit-row">
                  <Table className="sub-audit-table">
                    <Table.Header>
                      <Table.Row>
                        <Table.HeaderCell style={{ width: "15em" }}>
                          {t("AuditTrailTableHeaders.User")}
                        </Table.HeaderCell>
                        <Table.HeaderCell style={{ width: "12em" }}>
                          {t("AuditTrailTableHeaders.Timestamp")}
                        </Table.HeaderCell>
                        <Table.HeaderCell style={{ width: "15em" }}>
                          {t("AuditTrailTableHeaders.StatusChangedFrom")}
                        </Table.HeaderCell>
                        <Table.HeaderCell style={{ width: "15em" }}>
                          {t("AuditTrailTableHeaders.StatusChangedTo")}
                        </Table.HeaderCell>
                        <Table.HeaderCell></Table.HeaderCell>
                      </Table.Row>
                    </Table.Header>
                    <Table.Body>
                      {item.documentSubAudits &&
                        item.documentSubAudits.map((subAudit, subIndex) => {
                          let statusChangedFrom = "";
                          let statusChangedTo = "";

                          if (subAudit.usePhysicalDocument) {
                            statusChangedFrom = process.env.TRADE_AS_IPS
                              ? tPhysicalDocumentState(
                                  subAudit.physicalSourceStateIps,
                                )
                              : tPhysicalDocumentState(
                                  subAudit.physicalSourceStatePrincipal,
                                );
                            statusChangedTo = process.env.TRADE_AS_IPS
                              ? tPhysicalDocumentState(
                                  subAudit.physicalDestinationStateIps,
                                )
                              : tPhysicalDocumentState(
                                  subAudit.physicalDestinationStatePrincipal,
                                );
                          } else {
                            statusChangedFrom = process.env.TRADE_AS_IPS
                              ? tState(subAudit.sourceStateIps)
                              : tState(subAudit.sourceStatePrincipal);
                            statusChangedTo = process.env.TRADE_AS_IPS
                              ? tState(subAudit.destinationStateIps)
                              : tState(subAudit.destinationStatePrincipal);
                          }

                          return (
                            <Table.Row key={subIndex}>
                              <Table.Cell>{subAudit.fullName}</Table.Cell>
                              <Table.Cell>{subAudit.timestamp}</Table.Cell>
                              <Table.Cell>{statusChangedFrom}</Table.Cell>
                              <Table.Cell>{statusChangedTo}</Table.Cell>
                            </Table.Row>
                          );
                        })}
                    </Table.Body>
                  </Table>
                </Table.Cell>
              </Table.Row>
            </React.Fragment>
          ))}
      </Table.Body>
    </Table>
  );
};

export default DocumentAuditTrailTable;
